export enum LocalStorageKeys {
  ImageSetOrder = 'ImageSetOrder',
  Inference = 'Inference',
  LabelingToolGPUWarning = 'LabelingToolGPUWarning',
  LabelingToolHttpWarning = 'LabelingToolHttpWarning',
  LicenseNotificationShown = 'LicenseNotificationShown',
  PoolMetadataFilters = 'PoolMetadataFilters',
  ProjectReadOnlyDialogShown = 'ProjectReadOnlyDialogShown',
  SetMetadataFilters = 'SetMetadataFilters',
  ShowPopupNotifications = 'ShowPopupNotifications',
  TestCenterMetadataFilters = 'TestCenterMetadataFilters',
}
